import { ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { SonderAvatarComponent } from '@sondermind/ai-chat-angular';
import { W9TinType } from '../../models/w9-tin-type';

const TIN_LABELS: Record<W9TinType, string> = {
  ssn: 'Social Security Number',
  ein: 'Employer Identification Number',
};

/**
 * The persistent Sonder intro message at the top of the chat thread. It stays
 * visible even after the provider sends their first question (it is not a
 * disappearing empty-state). Copy mirrors the authoritative design's first
 * Sonder bubble, scoped to the W-9 review page.
 */
@Component({
  selector: 'member-w9-desk-brief-welcome',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SonderAvatarComponent],
  styleUrls: ['./w9-desk-brief-welcome.component.scss'],
  templateUrl: './w9-desk-brief-welcome.component.html',
})
export class W9DeskBriefWelcomeComponent {
  @Input() set firstName(value: string | null | undefined) {
    this._firstName.set(value ?? '');
  }

  @Input() set tinType(value: string | null | undefined) {
    this._tinType.set((value ?? '').toLowerCase() === 'ein' ? 'ein' : 'ssn');
  }

  private readonly _firstName = signal('');
  private readonly _tinType = signal<W9TinType>('ssn');

  readonly greeting = computed(() => {
    const name = this._firstName().trim();
    return name ? `Hi ${name}` : 'Hi there';
  });

  // A W-9 carries exactly one TIN, so the label is SSN or EIN — never both.
  readonly tinLabel = computed(() => TIN_LABELS[this._tinType()]);
}
